import { type IBrokerContext } from '../../context'
import { type IBrokerPlugin } from '../plugin'
import { type IBrokerPluginInstaller, type BrokerPluginInstallOption, createPluginContext } from './base'

export interface LocalBrokerPluginInstallOption extends BrokerPluginInstallOption<'local'> {
  plugin: IBrokerPlugin
}

export class LocalBrokerPluginInstaller implements IBrokerPluginInstaller<'local', LocalBrokerPluginInstallOption> {
  async install (ctx: IBrokerContext, installOption: LocalBrokerPluginInstallOption): Promise<IBrokerPlugin> {
    const id = installOption.plugin.id
    if (id == null) throw new Error('The plugin does not have an id.')
    await installOption.plugin.install(createPluginContext(installOption.plugin.id, ctx, installOption))
    return installOption.plugin
  }

  async uninstall (module: IBrokerPlugin, ctx: IBrokerContext): Promise<void> {
    await module?.uninstall?.(ctx)
  }
}
